<template>
  <div>
    <CandidateInterviewProcessing v-if="isOfficeInterviewProcessing" />
    <CandidateInterviewProcessingFailed v-else-if="isOfficeInterviewProcessingFailed" />
    <CandidateInterviewOffice
      v-else-if="showOfficeInterviewPlayer"
      v-model="officeInterviewPlayerTime"
      :interview="interview"
    />
  </div>
</template>

<script>
import { interviewStatuses } from '../../../enums';
import CandidateInterviewProcessing from '../CandidateInterviewProcessing.vue';
import CandidateInterviewProcessingFailed from '../CandidateInterviewProcessingFailed.vue';
import CandidateInterviewOffice from '../CandidateInterviewOffice.vue';

export default {
  name: 'UploadedVideoInterview',
  components: {
    CandidateInterviewProcessing,
    CandidateInterviewProcessingFailed,
    CandidateInterviewOffice,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    interview: {
      required: true,
    },
  },
  computed: {
    officeInterviewPlayerTime: {
      get() {
        return this.$store.state.candidatePage.officeInterviewPlayerTime;
      },
      set(value) {
        this.$store.commit('candidatePage/setOfficeInterviewPlayerTime', value);
      },
    },
    showOfficeInterviewPlayer() {
      return this.interview
        && this.interview.status === interviewStatuses.READY;
    },
    isOfficeInterviewProcessing() {
      return this.interview
        && (this.interview.status === interviewStatuses.PROCESSING
          || this.interview.status === interviewStatuses.BLANK);
    },
    isOfficeInterviewProcessingFailed() {
      return this.interview
        && this.interview.status === interviewStatuses.PROCESSING_FAILED;
    },
  },
};
</script>

<style scoped>

</style>
